import { useContext } from "react";
import elementsContext from "../elementsContext";

export default function useElements() {
  return useContext(elementsContext);
}
